import axios from "@/libs/api.request";
import { auth } from "./api_url";
/**
 * 获取自己的角色列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const getmygroup = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmygroup,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 登录成功获取当前用户菜单
 * @param data
 * @returns {*|{responseURL}}
 */
export const login_success_permission = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.login_success_permission,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 配置账号的权限
 * @param data
 * @returns {*|{responseURL}}
 */
export const Permission_config = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.Permission_config,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 账号管理 权限配置页面（获取菜单列表和接口列表）
 * @param data
 * @returns {*|{responseURL}}
 */
export const getmenu_permission = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmenu_permission,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取子账号列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const getadminlist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getadminlist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除子账号
 * @param data
 * @returns {*|{responseURL}}
 */
export const admin_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.admin_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑子账号
 * @param data
 * @returns {*|{responseURL}}
 */
export const admin_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.admin_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 禁用启用子账号
 * @param data
 * @returns {*|{responseURL}}
 */
export const change_adminstatus = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.change_adminstatus,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增子账号
 * @param data
 * @returns {*|{responseURL}}
 */
export const adduser = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.adduser,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
//获取用户列表

/**
 * 获取所有角色列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const getgrouplist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getgrouplist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 角色管理 角色权限配置 保存操作
 * @param data
 * @returns {*|{responseURL}}
 */
export const groupPermission_config = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.groupPermission_config,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 角色管理 角色权限配置获取基本数据
 * @param data
 * @returns {*|{responseURL}}
 */
export const getgroup_permission = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getgroup_permission,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 编辑角色
 * @param data
 * @returns {*|{responseURL}}
 */
export const group_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.group_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除角色
 * @param data
 * @returns {*|{responseURL}}
 */
export const delgroup = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.delgroup,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取角色列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const grouplist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.grouplist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增角色
 * @param data
 * @returns {*|{responseURL}}
 */
export const addgroup = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addgroup,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 菜单接口配置时执行保存操作
 * @param data
 * @returns {*|{responseURL}}
 */
export const api_config_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.api_config_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 菜单列表接口配置时获取基本数据
 * @param data
 * @returns {*|{responseURL}}
 */
export const api_config_data = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.api_config_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑菜单
 * @param data
 * @returns {*|{responseURL}}
 */
export const menu_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.menu_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除菜单
 * @param data
 * @returns {*|{responseURL}}
 */
export const menu_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.menu_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取菜单列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const getmenulist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmenulist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增菜单或页面
 * @param data
 * @returns {*|{responseURL}}
 */
export const addmenu = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addmenu,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 根据模块名称获取接口列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const getmodule_api = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmodule_api,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑接口
 * @param data
 * @returns {*|{responseURL}}
 */
export const resource_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.resource_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除接口
 * @param data
 * @returns {*|{responseURL}}
 */
export const resourcedel = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.resourcedel,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取接口列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const resourcelist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.resourcelist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增接口
 * @param data
 * @returns {*|{responseURL}}
 */
export const addresource = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addresource,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取模块列表（新增接口时）
 * @param data
 * @returns {*|{responseURL}}
 */
export const getmodule = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmodule,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑模块
 * @param data
 * @returns {*|{responseURL}}
 */
export const module_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.module_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除模块
 * @param data
 * @returns {*|{responseURL}}
 */
export const moduledel = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.moduledel,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取模块列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const modulelist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.modulelist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增模块
 * @param data
 * @returns {*|{responseURL}}
 */
export const addmodule = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addmodule,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
//设置默认角色
export const default_role = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.default_role,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
//获取用户列表
export const getUserlist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_list',
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
//新增用户
export const addUserlist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_add',
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
//禁用启用用户
export const openOroffUser = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_status',
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
//删除用户
export const delUser = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_del',
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
//编辑用户
export const editUser = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_update',
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
